import { createFileRoute, redirect } from "@tanstack/react-router";
import { BookingsPage } from "@/app/partner/pages/bookings";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/bookings")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "bookings");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard/leads" });
		}
	},
	component: BookingsRoute,
});

function BookingsRoute() {
	return <BookingsPage />;
}
